import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaperkmmrateinpune() {



  const cardData = {
"keyword": "Urbania per km rate in Pune",

"headingDescription":
  "Shivai Travels offers affordable and transparent Urbania per km rental services in Pune for comfortable group travel including family tours, corporate trips, wedding transportation, pilgrimage journeys, airport transfers, and outstation travel across Maharashtra and India. Our Force Urbania vehicles are designed for premium comfort with spacious pushback seating, strong air conditioning, smooth suspension, charging points, music system, and ample luggage space, ensuring a safe and relaxed journey for all passengers. The Urbania per km rate in Pune generally depends on seating capacity, travel distance, route type, and trip duration, making it a flexible option for both local and long-distance travel. Ideal for 15–17 passengers, Shivai Travels ensures professional drivers, well-maintained vehicles, doorstep pickup and drop, and 24/7 support for a smooth and reliable group travel experience.",

"topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description":
      "Lonavala and Khandala are the most popular hill stations near Pune known for waterfalls, green valleys, forts, and monsoon beauty, making them ideal for budget-friendly Urbania per km trips."
  },
  {
    "title": "Mahabaleshwar & Panchgani",
    "description":
      "Mahabaleshwar and Panchgani are famous hill stations known for strawberries, viewpoints, lakes, and cool climate, ideal for comfortable per km group travel from Pune."
  },
  {
    "title": "Goa",
    "description":
      "Goa is a top long-distance destination from Pune known for beaches, nightlife, water sports, and resorts, making it suitable for per km Urbania pricing for road trips."
  },
  {
    "title": "Shirdi",
    "description":
      "Shirdi is a major pilgrimage destination dedicated to Sai Baba, frequently visited by devotees using Urbania rental on per km basis from Pune."
  },
  {
    "title": "Nashik & Trimbakeshwar",
    "description":
      "Nashik and Trimbakeshwar are spiritual and wine tourism destinations known for temples, vineyards, and religious journeys, ideal for per km group travel pricing."
  },
  {
    "title": "Alibaug",
    "description":
      "Alibaug is a coastal getaway near Mumbai known for beaches, forts, and resorts, making it a popular per km Urbania destination from Pune."
  },
  {
    "title": "Konkan Beaches (Murud, Kashid, Ganpatipule)",
    "description":
      "Konkan beaches offer scenic coastal drives, clean beaches, and peaceful surroundings, ideal for flexible per km Urbania road trip pricing."
  },
  {
    "title": "Ajanta & Ellora Caves",
    "description":
      "Ajanta and Ellora Caves near Aurangabad are UNESCO World Heritage Sites known for ancient rock-cut architecture and cultural tourism, suitable for long per km travel trips."
  },
  {
    "title": "Mumbai City Tour",
    "description":
      "Mumbai is a major metro destination known for Marine Drive, Gateway of India, and shopping areas, commonly covered under Urbania per km rental packages from Pune."
  },
  {
    "title": "Lavasa",
    "description":
      "Lavasa is a planned hill city near Pune known for lakeside views, modern architecture, and pleasant weather, ideal for short per km Urbania trips."
  }
],



services: [
  {
    name: "Urbania Per KM Pune",
    description: "Urbania per KM Pune service provides premium and spacious transportation for airport transfers, family trips, corporate travel, sightseeing tours, weddings, and outstation journeys with flexible kilometer-based travel options. Luxury Force Urbania vehicles with experienced drivers ensure smooth and safe travel for local and long-distance routes. Pickup services are available from homes, hotels, railway stations, offices, and airport terminals across Pune. Vehicles offer pushback seating, air conditioning, premium interiors, and luggage space suitable for executive and family travel requirements. Flexible booking options allow convenient Urbania per kilometer reservations in Pune."
  },
  {
    name: "Urbania Rate Per KM Pune",
    description: "Urbania rate per KM Pune service offers dependable transportation solutions for travelers seeking comfortable group travel with kilometer-based pricing options. Vehicles provide spacious seating and smooth highway travel suitable for tourism, corporate outings, airport travel, and family vacations. Professional chauffeurs ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient Urbania rate per KM reservations."
  },
  {
    name: "Force Urbania Fare Pune",
    description: "Force Urbania fare Pune service provides affordable and comfortable executive travel options for local and outstation journeys with flexible fare plans. Travelers can enjoy smooth trips with experienced drivers familiar with city roads, highways, and tourist destinations. Vehicles ensure spacious seating and safe transportation suitable for business trips, family vacations, and airport travel. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Force Urbania fare reservations."
  },
  {
    name: "Urbania Taxi Charges Pune",
    description: "Urbania taxi charges Pune service provides high-end transportation for passengers seeking comfortable and stylish group travel with convenient pricing plans. Vehicles offer spacious seating, premium interiors, luggage capacity, and smooth ride quality suitable for tourism, wedding events, and executive travel. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Urbania taxi charge reservations."
  },
  {
    name: "Cheap Urbania Per KM Pune",
    description: "Cheap Urbania per KM Pune service offers economical and comfortable transportation for groups traveling within Pune and nearby destinations. Vehicles provide smooth highway travel with spacious seating suitable for one-day tours, airport transfers, and group outings. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient affordable Urbania reservations."
  },
  {
    name: "Luxury Urbania Pricing Pune",
    description: "Luxury Urbania pricing Pune service provides comfortable transportation for families, corporate teams, and tourists traveling within Pune and outstation destinations with premium travel options. Vehicles ensure smooth highway travel with spacious seating and luggage capacity suitable for tourism, pilgrimage tours, and weekend trips. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient luxury Urbania pricing reservations."
  },
  {
    name: "Urbania Outstation Rate Pune",
    description: "Urbania outstation rate Pune service offers spacious transportation for family tours, corporate outings, weddings, and sightseeing trips with flexible outstation travel rates. Vehicles provide comfortable seating, air conditioning, and smooth highway performance suitable for long-distance journeys and executive travel. Professional chauffeurs ensure safe driving and timely pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient outstation Urbania reservations."
  },
  {
    name: "Airport Urbania Fare Pune",
    description: "Airport Urbania fare Pune service provides reliable transportation for airport pickup and drop services from Pune Airport and nearby locations with affordable airport transfer pricing. Vehicles offer spacious seating, luggage space, and comfortable travel suitable for family groups, corporate teams, and tourist travelers. Professional drivers ensure smooth travel and dependable pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient airport Urbania fare reservations."
  },
  {
    name: "Urbania Booking Charges Pune",
    description: "Urbania booking charges Pune service provides dependable transportation for long-distance group travel from Pune to tourist destinations, pilgrimage places, beaches, and hill stations with convenient booking plans. Comfortable vehicles ensure smooth highway travel suitable for tourism, corporate tours, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the journey. Pickup services are available across Pune including homes, hotels, railway stations, and airports. Flexible booking options allow convenient Urbania booking reservations."
  },
  {
    name: "Urbania One Way Rate Pune",
    description: "Urbania one way rate Pune service offers spacious and comfortable transportation for one-side travel from Pune to nearby cities and tourist destinations with flexible one-way travel options. Vehicles provide comfortable seating and luggage space suitable for family groups, business teams, and tourist travelers. Professional drivers ensure punctual transfers and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient one-way Urbania reservations."
  },
  {
    name: "Urbania Round Trip Charges Pune",
    description: "Urbania round trip charges Pune service offers premium transportation for sightseeing tours, family vacations, pilgrimage journeys, and business travel with return travel pricing options. Vehicles ensure comfortable seating and smooth travel suitable for large family groups and corporate outings. Professional chauffeurs ensure safe driving and timely pickup services for all travel requirements. Pickup services are available from homes, hotels, banquet halls, railway stations, and airports across Pune. Flexible booking options allow convenient round trip Urbania reservations."
  },
  {
    name: "Best Urbania Rates Pune",
    description: "Best Urbania rates Pune service offers reliable group transportation for airport pickup and drop services, sightseeing tours, and outstation travel with budget-friendly travel options. Vehicles provide spacious seating and luggage space suitable for family groups, corporate teams, and tourist travelers. Professional drivers ensure punctual transfers and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient best Urbania rate reservations."
  },
  {
    name: "Urbania with Driver Charges Pune",
    description: "Urbania with driver charges Pune service provides complete luxury transportation solutions for local and outstation group travel requirements with professional chauffeur services. Vehicles ensure smooth highway travel suitable for tourism, corporate events, pilgrimage tours, and family vacations. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Urbania with driver reservations."
  },
  {
    name: "Premium Urbania KM Rate Pune",
    description: "Premium Urbania KM rate Pune service offers comfortable and dependable transportation with modern vehicles and experienced chauffeurs for local and outstation travel. Vehicles are suitable for family trips, sightseeing tours, airport transfers, corporate outings, and long-distance travel. Professional drivers ensure safe driving and reliable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient premium Urbania KM rate reservations."
  },
  {
    name: "Pune Urbania Tariff",
    description: "Pune Urbania tariff service provides luxury transportation for groups looking for premium travel experiences with spacious seating and comfortable interiors along with flexible travel tariff options. Vehicles are suitable for corporate events, destination outings, sightseeing trips, airport travel, and family tours. Professional chauffeurs ensure smooth journeys and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Pune Urbania tariff reservations."
  }
],

tableData: [
  ["Urbania Per KM Pune", "Urbania Rate Per KM Pune"],
  ["Force Urbania Fare Pune", "Urbania Taxi Charges Pune"],
  ["Cheap Urbania Per KM Pune", "Luxury Urbania Pricing Pune"],
  ["Urbania Outstation Rate Pune", "Airport Urbania Fare Pune"],
  ["Urbania Booking Charges Pune", "Urbania One Way Rate Pune"],
  ["Urbania Round Trip Charges Pune", "Best Urbania Rates Pune"],
  ["Urbania with Driver Charges Pune", "Premium Urbania KM Rate Pune"],
  ["Pune Urbania Tariff", "Urbania Per KM Pune"]
],


 whychoose: [
      {
        WhyChooseheading: "Affordable Urbania Per KM Rate in Pune",
        WhyChoosedescription: "Shivai Travels offers affordable Urbania per km rates in Pune with transparent pricing, flexible packages, and no hidden charges for local and outstation travel."
      },
      {
        WhyChooseheading: "Transparent Urbania Pricing Structure",
        WhyChoosedescription: "Customers receive complete fare details before booking including per kilometer charges, driver allowance, toll charges, and parking information for hassle-free travel planning."
      },
      {
        WhyChooseheading: "Luxury Urbania Vehicles for Group Travel",
        WhyChoosedescription: "All Urbania vehicles provided by Shivai Travels are fully air-conditioned, spacious, sanitized, and maintained for premium comfort during local and long-distance travel."
      },
      {
        WhyChooseheading: "Flexible Urbania Rental Packages",
        WhyChoosedescription: "Shivai Travels offers one-way, round-trip, local city packages, airport transfers, corporate bookings, wedding travel, and customized outstation Urbania rental packages from Pune."
      },
      {
        WhyChooseheading: "Multiple Urbania Seating Options",
        WhyChoosedescription: "Customers can choose from 10 seater, 13 seater, and 17 seater Urbania vehicles depending on group size, luggage requirements, and travel preferences."
      },
      {
        WhyChooseheading: "24/7 Urbania Rental Availability",
        WhyChoosedescription: "Our Urbania rental service in Pune operates 24 hours a day for family tours, corporate outings, pilgrimage trips, airport transfers, and emergency travel requirements."
      },
      {
        WhyChooseheading: "Professional Drivers for Long-Distance Travel",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune highways, hill stations, Konkan roads, and interstate routes, ensuring safe driving and smooth travel for every journey."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, and Hadapsar."
      }
    ]
  };

  const faqData = [
    { question: "What is the Urbania per km rate in Pune?", answer: "Urbania per km rates in Pune generally start from ₹30 to ₹40 per kilometer depending on seating capacity, travel duration, and route." },
    { question: "What is the 13 seater Urbania per km rate in Pune?", answer: "The 13 seater Urbania per km rate in Pune usually starts from ₹31 to ₹36 per kilometer for outstation travel." },
    { question: "What is the 17 seater Urbania per km rate in Pune?", answer: "The 17 seater Urbania per km rate in Pune generally starts from ₹33 to ₹40 per kilometer depending on travel requirements." },
    { question: "Do Urbania rental charges include driver allowance?", answer: "Driver allowance, toll charges, and parking charges may be extra depending on the package and travel destination." },
    { question: "Is Urbania available for local Pune travel?", answer: "Yes, Shivai Travels provides Urbania rental service for local Pune sightseeing, city tours, airport transfers, and corporate travel." },
    { question: "Can I book Urbania for outstation travel from Pune?", answer: "Yes, customers can book Urbania vehicles for outstation travel including Mumbai, Goa, Shirdi, Mahabaleshwar, Bangalore, and Konkan tours." },
    { question: "Are all Urbania vehicles air-conditioned?", answer: "Yes, all Urbania vehicles are fully air-conditioned and maintained for comfortable luxury travel." },
    { question: "Can I book Urbania online in Pune?", answer: "Yes, customers can easily book Urbania rental service online or through phone booking." },
    { question: "Do you provide Urbania for weddings and corporate events?", answer: "Yes, Shivai Travels provides Urbania vehicles for weddings, corporate outings, VIP travel, and family group transportation." },
    { question: "Is advance booking available for Urbania rental in Pune?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Rohit Patil",
      feedback:
        "Booked Urbania on rent in Pune with Shivai Travels. Reasonable per km pricing, luxury vehicle, and excellent driver support for our group trip.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Snehal Kulkarni",
      feedback:
        "Excellent Urbania rental service in Pune. Affordable pricing, clean luxury vehicle, and wonderful long-distance travel experience.",
      rating: 5
    }
  ];


  

  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Per KM Rate in Pune",
  "image": "https://shivaitravels.com/assets/images/urbania-rate-pune.jpg",
  "description": "Book Urbania on rent in Pune with Shivai Travels at transparent per KM pricing. Ideal for airport transfers, outstation trips, family travel, and group journeys. Available with AC comfort, professional driver, and flexible one-way and round-trip options.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹28–₹40/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/urbania-per-km-rate-pune"
  }
};




  return (
    <div>
<Helmet>
  <title>Urbania Per KM Rate in Pune | Force Urbania Fare & Pricing | Shivai Travels | +91 9689815477</title>

  <meta
    name="description"
    content="Check Urbania per km rate in Pune with Shivai Travels. Transparent pricing for AC Urbania rental for airport, outstation, one-way, round-trip and group travel services with driver."
  />

  <meta
    name="keywords"
    content="urbania per km pune, urbania rate per km pune, force urbania fare pune, urbania taxi charges pune, cheap urbania per km pune, luxury urbania pricing pune, urbania outstation rate pune, airport urbania fare pune, urbania booking charges pune, urbania one way rate pune, urbania round trip charges pune, best urbania rates pune, urbania with driver charges pune, premium urbania km rate pune, pune urbania tariff"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/3.png' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Urbaniaperkmmrateinpune;